import React, { useState, useEffect } from 'react'
import { Grid, TextField, Typography, Button } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { useHistory } from 'react-router-dom'
import { Routes } from '../../router/routes'
import { withRouter } from 'react-router'
import axios from 'axios';

const useStyles = makeStyles(theme => ({
  textInput: {
    height: 35
  },
  fullHeight: {
    height: '100vh',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 20,
    backgroundColor: "#F3F6FF"
  },
  columnSection: {
    justifyContent: 'center',
    display: 'flex',
    width: 370,
    background: '#fff',
    padding: 18,
    borderRadius: '12px',
    boxShadow: '0px 5px 23px #00000014'
  },
  headerSection: {
    justifyContent: 'center',
    display: 'flex',
    alignItems: 'center',
    marginBottom: 50,
    marginTop: 4
  },
  rowView: {
    marginBottom: 20
  },
  logo: {
    width: 50,
    height: 50,
    borderRadius: 100,
    marginRight: 20
  }
}))

const Login = (props) => {

  const classes = useStyles(props);

  const [state, setState] = useState({
    email_id: "",
    password: "",
    error: {
      email_id: "",
      password: "",
    },
    message: ''
  })
  useEffect(async () => {
    let urlParams = new URLSearchParams(window.location.search);
    let metadataIdFromURL = urlParams?.get("metadata_id");
    let tokenFromUrl = urlParams.get("token");
    if (tokenFromUrl && metadataIdFromURL) {
      var data = JSON.stringify({
        "db_name": "ATP_Platform_DEV",
        "entity": "projectvstools",
        "filter": "projectvstools.metadataid == '" + metadataIdFromURL + "'",
        "return_fields": "DOCUMENT(projectvstools.projectid)"
      });

      var config = {
        method: 'post',
        url: 'https://arangodbservice.dev.ainqaplatform.in/api/read_documents',
        headers: {
          'Content-Type': 'application/json'
        },
        data: data
      };

      let res = await axios(config)
      debugger
      let dbname = res?.data?.result?.[0]?.projectdbname ?? "ATP_Platform_DEV"
      localStorage.setItem("DBNAME", dbname)
      localStorage.setItem("payload", tokenFromUrl)
      props.history.push(Routes.home)
    }
    // if (sessionStorage.getItem('payload')) {
    //   props.history.push(Routes.home)
    // }
  }, []);
  const history = useHistory();
  const validate = () => {

    let isValidated = true;

    if (!state.email_id) {
      isValidated = false;
      state.error.email_id = "Enter email id";
    }

    if (!state.password) {
      isValidated = false;
      state.error.password = "Enter password";
    }

    setState({ ...state })
    return isValidated;
  }



  const handleLogin = async () => {

    if (!validate()) {
      return false;
    }

    let params = {
      email: state.email_id,
      password: state.password,
    }

    const Config = {
      key_cloak_client_id: process.env.REACT_APP_KEY_CLOAK_CLIENT_ID,
      key_cloak_secret_key: process.env.REACT_APP_KEY_CLOAK_SECRET_KEY,
      key_cloak_api: process.env.REACT_APP_KEY_CLOAK_API,
      key_cloak_db: process.env.REACT_APP_KEY_CLOAK_DB
    }
    var myHeaders = { "Content-Type": "application/x-www-form-urlencoded" };

    var urlencoded = new URLSearchParams();
    urlencoded.append("client_id", Config.key_cloak_client_id);
    urlencoded.append("client_secret", Config.key_cloak_secret_key);
    urlencoded.append("username", params.email);
    urlencoded.append("password", params.password);
    urlencoded.append("grant_type", "password");

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      data: urlencoded,
      redirect: 'follow',
      url: `${Config.key_cloak_api}/auth/realms/${Config.key_cloak_db}/protocol/openid-connect/token`
    };

    let keyClock = await axios(requestOptions)
      .catch((error) => {
        setState({
          ...state,
          message: "Invalid Credentials"
        })
      })
    if (!keyClock) {
      return
    }
    sessionStorage.setItem('payload', JSON.stringify(keyClock.data));
    debugger
    props.history.push(Routes.home);

    // if (params.email === "admin@ainqa.com" && params.password === "ainqa@12345") {
    //   // window.location.href = routes.home;
    //   history.push(routes.home);
    // }else{
    //   setState({
    //     ...state,
    //     message : "Invalid Credentials"
    //   })
    // }
  }

  const keydownFunc = (event, sectionId) => {
    if (event.keyCode === 13) {
      handleLogin()
    }
  }



  return (
    <div className={classes.fullHeight}>

      <Grid container className={classes.columnSection}>
        {/* <Grid>
          <img src="/images/icons/logo.png" alt="logo" style={{
            height: "50px",
            width: "50px",
            "object-fit": "contain",
          }} />
        </Grid> */}
        <Grid item xs={12} className={classes.headerSection}>
          <Typography variant='h4'>QDM Form Configurator</Typography>
        </Grid>

        <Grid item xs={12} sm={12} md={12}>

          <div className={classes.rowView}>
            <TextField
              fullWidth
              label="Email Id"
              variant="standard"
              value={state.email_id}
              placeholder={'ide@example.com'}
              error={state.error.email_id}
              helperText={state.error.email_id}
              onChange={(e) => setState({ ...state, email_id: e.target.value, error: { ...state.error, email_id: "" }, message: "" })}
            />
          </div>

          <div className={classes.rowView}>

            <TextField
              fullWidth
              variant='standard'
              label="Password"
              type='password'
              InputLabelProps={{
                shrink: true
              }}
              InputProps={{
                className: classes.textInput
              }}
              value={state.password}
              placeholder={'Password'}
              error={state.error.password}
              onKeyDown={(e) => keydownFunc(e)}
              helperText={state.error.password}
              onChange={(e) => setState({ ...state, password: e.target.value, error: { ...state.error, password: "" }, message: "" })}
            />

          </div>

          <div>
            <Typography variant="body1" gutterBottom align="center" color="error">
              {state.message}
            </Typography>
          </div>

          <div className={classes.rowView}>
            <Button
              variant='contained'
              color='primary'
              fullWidth
              // disabled={loading}
              onClick={handleLogin}
            >
              Log In
            </Button>
          </div>

        </Grid>

      </Grid>

    </div>
  )
}
export default withRouter(Login);